<template> 
    <v-layout>
        
        <keep-alive>        
            <component 
                :is="mainform"
                :formdata="formdata"  
                v-on:submitcomplete="onSubmitComplete"
            ></component>

        </keep-alive>
        <formstopperdialog 
            :show="loading">            
        </formstopperdialog>
    </v-layout>
</template>
<script>
    import { mapGetters } from 'vuex';
    import formstopperdialog from "../components/forms/FormStopperDialog.vue";
    import mainform from "../components/forms/MainForm.vue";
    
    export default {   
    
    props: [
        
    ],
    components: {
        mainform,
        formstopperdialog,    
    },
    data() {
        return {  
            mainform:mainform,    
            formstopperdialog: formstopperdialog,
            loading:false                    
        }
    },
    
    computed: {
        ...mapGetters({
            formdata: 'entities/formdata',
            ingredients: 'entities/ingredients'
        }),
        routeid(){return this.$route.params.id},
        show(){return this.loading}
    },
    methods: {
        onSubmitComplete: function(submitted, id){   
                                    
            if(!submitted) {
                this.$router.push({ 
                name: 'entities'})
                
            } else {
                this.$router.push({ 
                name: 'entities_update', 
                params: { 
                        id: id 
                }})
            }
        },
        async init(){
            this.loading=true
            await Promise.all([ 
                this.$store.dispatch('entitycategories/getAll'),
                this.$store.dispatch('units/getAll'),
                this.$store.dispatch('tagcategories/getAll'),
                this.$store.dispatch('specifications/getAll'),
                this.$store.dispatch('treatments/getAll'),
                this.$store.dispatch('tags/getAll'), 
                this.$store.dispatch('preparations/getAll'),
                this.$store.dispatch('companies/getAll'),
                this.$store.dispatch('logos/getAll'),  
                this.$store.dispatch('recipesteps/getAll'),                            
                this.$store.dispatch('entities/getAll'),  
                
            ])
            
            if(typeof this.$route.params.id != 'undefined') {   
                let payload = {}
                payload.needle = [parseInt(this.$route.params.id)]
                payload.res=[]                
                await this.$store.dispatch('entities/forrecipe',payload)
                await this.$store.dispatch('entities/getById', this.$route.params.id)
                this.$store.commit('recipesteps/RECIPESTEP_SET_FORRECIPE', this.$route.params.id)                
                console.log('done')
            }
            this.loading=false
        }
    },
    mounted() {
        this.init()
        
    }
    
    
}
</script>
